"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndBlock = void 0;
const react_1 = __importDefault(require("react"));
const store_1 = require("../store");
const react_i18next_1 = require("react-i18next");
const EndBlock = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    return (react_1.default.createElement("div", { className: "flex" },
        react_1.default.createElement("div", { className: "flex w-6 xs:w-10 mr-2 justify-center flex-shrink-0" }),
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("p", { className: "text-sm mb-2 text-on-chat" }, t("Create yours for free")),
            react_1.default.createElement("a", { className: "bg-blue-500 px-6 py-2 rounded-md text-white focus:outline-none text-center typebot-button", href: "https://www.typebot.io/?utm_source=createbutton" +
                    (chatbot.settings.referralUtm
                        ? `&via=${chatbot.settings.referralUtm}`
                        : ""), target: "_blank", rel: "noreferrer" },
                "\uD83D\uDE80 ",
                t("Create a typebot")))));
};
exports.EndBlock = EndBlock;
//# sourceMappingURL=EndBlock.js.map